export default class {
  // 刷新列表,并更新badge数量
  async fetchList(type) {
    if (!type) {
      type = 'conflict';
    }
    const input = (type === 'conflict') ? this.conflictList.input.value : this.tradeMissList.input.value;
    // input.stationCode = this.stationCode;
    // if (!input.stationCode) {
    //   return [];
    // }
    try {
      const res = await this.http({ cmd: 'carFlow/listAlarm', input });
      if (type === 'conflict') {
        this.conflictList.output.value.rows = res.data;
        this.badge.conflict += this.conflictList.output.value.rows.length;
      } else {
        this.tradeMissList.output.value.rows = res.data;
        this.badge.tradeMiss += this.tradeMissList.output.value.rows.length;
      }
      const rows = res.data;
      this.methods('addToTextQueue', type, rows);
      return rows;
    } catch (e) {
      console.log('警报列表获取失败:', e);
      return [];
    }
  }

  // 初始化轮询
  async initInterval() {
    // 车型不一致轮询
    this.refreshinterval = setInterval(async () => {
      let rows = await this.methods('fetchList', 'conflict');
      if (rows.length !== 0) {
        // 将语音加入播放队列自动播放
        this.methods('startAlarm');
        // 更新下一次查询时间
        this.conflictList.input.value.matchTimeBegin = this.methods('getUpdateLastTime', rows);
      }
      // 两种类型之间间隔2秒
      await new Promise((r, e) => {
        setTimeout(() => {
          r();
        }, 2000);
      });
      rows = await this.methods('fetchList', 'tradeMiss');
      if (rows.length !== 0) {
        this.methods('startAlarm');
        this.tradeMissList.input.value.matchTimeBegin = this.methods('getUpdateLastTime', rows);
      }
    }, 30000);
    // 交易缺失轮询
    this.tradeMissInterval = setInterval(async () => {

    }, 10000);
  }

  // 将数据行加入语音队列
  addToTextQueue(type, rows) {
    if (!type) {
      type = 'conflict';
    }
    const typeText = type === 'conflict' ? '车型不一致' : '计费缺失';
    if (!rows || !rows.length) {
      return;
    }
    for (const row of rows) {
      const ssu = new window.SpeechSynthesisUtterance();
      const text = `${row.stationName}发现${typeText}车辆${row.plateNumber}`;
      ssu.rate = 1.5;
      ssu.text = text;
      ssu.notification = {
        stationCode: row.stationCode,
        typeText,
        stationName: row.stationName,
        plateNumber: row.plateNumber
      };
      this.textQueue.push(ssu);
    }
  }

  // 开始警报队列
  async startAlarm() {
    // 通知提示队列
    const nQueue = [];
    // 获取当前存在的语音对象，并加入全局speechSynthesis播放队列等待播放
    const textQueueLen = this.textQueue.length;
    for (let i = 0; i < textQueueLen; i++) {
      const uus = this.textQueue.shift();
      window.speechSynthesis.speak(uus);
      nQueue.push(uus.notification);
    }
    for (const n of nQueue) {
      await this.methods('notification', n);
    }
  }

  // 根据列表时间更新下一次查询时间
  getUpdateLastTime(rows) {
    // 按照时间升序
    rows = rows.sort((a, b) => {
      return new Date(a.createTime).getTime() - new Date(b.createTime).getTime();
    });
    return new Date((new Date(rows[rows.length - 1].createTime).getTime() + 1000)).format('yyyy-MM-dd hh:mm:ss');
  }

  // 根据语音队列中的信息弹出警报通知
  async notification(n) {
    const { typeText, stationCode, stationName, plateNumber } = n;
    let href = './#/conflict-vehicle';
    if (typeText === '计费缺失') {
      href = './#/trade-miss';
    }
    const text = `<span>${stationName}</span>发现<span style="color:#ffeb3b;">${typeText}</span>车辆:<span style="color:#ffeb3b;">${plateNumber}</span>`;
    this.notifications.push(this.$notify({
      title: `${typeText}警告`,
      message: `<p>${text}</p></p><a href="${href}" onclick="window.setAlarmQuery('${stationCode}','${plateNumber}')">前往查看</a>`,
      dangerouslyUseHTMLString: true,
      type: 'warning',
      position: 'bottom-right',
      // duration: 0
    }));
    // 每个通知间隔延时100ms
    await new Promise((r, e) => {
      setTimeout(() => {
        r();
      }, 100);
    });
  }
}
